import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { StringKeyValue } from '../actions/types';
import SigningComponent from '../components/Signing/SigningComponent';
import { AppState } from '../reducers';
import { ContextReducer } from '../reducers/context';
import { LbsReducer } from '../reducers/lbs';
import { SigningReducer } from '../reducers/signing';
import { UserReducer } from '../reducers/user';

interface Props {
    signing: SigningReducer;
    context: ContextReducer;
    text: StringKeyValue;
    user: UserReducer;
    lbs: LbsReducer;
}

const Signing = (props: Props) => {
    const { text, user, signing, lbs, context } = props;
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [props]);

    return <SigningComponent text={text} user={user} signing={signing} context={context} lbs={lbs} />;
};

const mapStateToProps = (state: AppState) => ({
    text: state.context.config.data.text,
    context: state.context,
    signing: state.signing,
    user: state.user,
    lbs: state.lbs,
});

export default connect(mapStateToProps)(Signing);
